import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from 'src/app/store/server-communication/running-actions/types/longRunningAction.decorator';
import { SkillUserConfigurationRemoteDto } from 'src/generated/signalR/skill-user-configuration-remote-dto';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';

export class ToggleAgentDetailsEditMode {
   public static readonly type = '[AgentDetails] Toggle Edit Mode';

   constructor() {}
}

export class ChangeSkillStatusOfSelectedAgent {
   public static readonly type = '[AgentDetails] Change Skill Status Of Selected Agent';

   constructor(public skillId, public shouldSkillBeActive: boolean) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.AGENT_DETAILS)
export class RefreshSelectedAgentData {
   public static readonly type = '[AgentDetails] Refresh Selected Agent Data';

   constructor() {}
}

export class UpdateAgentData {
   public static readonly type = '[AgentDetails] Update Agent Data';

   constructor(
      public userId: number,
      public skillsOfUser: SkillUserConfigurationRemoteDto[],
      public statusesOfUser: UserStatusInfoRemoteDto[],
      public featuresOfUser: string[]
   ) {}
}
